const api = {
  prod: process.env.VUE_APP_ROOT_API,
  dev: process.env.VUE_APP_ROOT_API
}
let apiEndPoint = process.env.NODE_ENV === 'production' ? api.prod : api.dev
if (process.env.API_ENDPOINT) {
  apiEndPoint = process.env.API_ENDPOINT
}
const apiBaseUrl = apiEndPoint + '/admin'
export default {
  users: {
    login: { method: 'post', url: `${apiBaseUrl}/users/login` },
    create: { method: 'post', url: `${apiBaseUrl}/users` },
    list: { method: 'get', url: `${apiBaseUrl}/users` },
    update: { method: 'put', url: `${apiBaseUrl}/users` },
    delete: { method: 'delete', url: `${apiBaseUrl}/users` }
  },
  userGroups: {
    create: { method: 'post', url: `${apiBaseUrl}/user_groups` },
    list: { method: 'get', url: `${apiBaseUrl}/user_groups` },
    update: { method: 'put', url: `${apiBaseUrl}/user_groups` },
    delete: { method: 'delete', url: `${apiBaseUrl}/user_groups` }
  },
  items: {
    create: { method: 'post', url: `${apiBaseUrl}/items` },
    list: { method: 'get', url: `${apiBaseUrl}/items` },
    upload: { method: 'post', url: `${apiBaseUrl}/items/upload` },
    delete: { method: 'delete', url: `${apiBaseUrl}/items` }
  },
  goods: {
    create: { method: 'post', url: `${apiBaseUrl}/goods` },
    list: { method: 'get', url: `${apiBaseUrl}/goods` },
    // update: { method: 'put', url: `${apiBaseUrl}/items` },
    delete: { method: 'delete', url: `${apiBaseUrl}/goods` }
  },
  categories: {
    create: { method: 'post', url: `${apiBaseUrl}/categories` },
    list: { method: 'get', url: `${apiBaseUrl}/categories` },
    update: { method: 'put', url: `${apiBaseUrl}/categories` },
    delete: { method: 'delete', url: `${apiBaseUrl}/categories` }
  },
  saleGroups: {
    create: { method: 'post', url: `${apiBaseUrl}/sale_groups` },
    list: { method: 'get', url: `${apiBaseUrl}/sale_groups` },
    get: { method: 'get', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}` },
    update: { method: 'put', url: `${apiBaseUrl}/sale_groups` },
    delete: { method: 'delete', url: `${apiBaseUrl}/sale_groups` }
  },
  stuff: {
    create: { method: 'post', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/stuff` },
    list: { method: 'get', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/stuff` },
    update: { method: 'put', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/stuff` },
    delete: { method: 'delete', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/stuff` }
  },
  banners: {
    create: { method: 'post', url: `${apiBaseUrl}/sliders` },
    list: { method: 'get', url: `${apiBaseUrl}/sliders` },
    update: { method: 'put', url: `${apiBaseUrl}/sliders` },
    delete: { method: 'delete', url: `${apiBaseUrl}/sliders` }
  },
  currencies: {
    create: { method: 'post', url: `${apiBaseUrl}/currencies` },
    list: { method: 'get', url: `${apiBaseUrl}/currencies` },
    update: { method: 'put', url: `${apiBaseUrl}/currencies` },
    delete: { method: 'delete', url: `${apiBaseUrl}/currencies` }
  },
  salePages: {
    create: { method: 'post', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/sale_pages` },
    list: { method: 'get', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/sale_pages` },
    update: { method: 'put', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/sale_pages` },
    delete: { method: 'delete', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/sale_pages` }
  },

  stores: {
    // create: { method: 'post', url: `${apiBaseUrl}/stores/` },
    get:{ method: 'get', url: `${apiBaseUrl}/stores`},
    list: { method: 'get', url: `${apiBaseUrl}/stores` },
    update: { method: 'put', url: `${apiBaseUrl}/stores` },
    // delete: { method: 'delete', url: `${apiBaseUrl}/stores/` }
  },
  branches: {
    create: { method: 'post', url: `${apiBaseUrl}/branches` },
    get:{ method: 'get', url: `${apiBaseUrl}/branches`},
    list: { method: 'get', url: `${apiBaseUrl}/branches` },
    update: { method: 'put', url: `${apiBaseUrl}/branches` },
    // delete: { method: 'delete', url: `${apiBaseUrl}/stores/` }
  },
  addpurchases: {
    create: { method: 'post', url: `${apiBaseUrl}/addpurchases` },
    // get:{ method: 'get', url: `${apiBaseUrl}/addpurchases`},
    list: { method: 'get', url: `${apiBaseUrl}/addpurchases` },
    update: { method: 'put', url: `${apiBaseUrl}/addpurchases` },
    // delete: { method: 'delete', url: `${apiBaseUrl}/stores/` }
  },
  
  imageUpload: { method: 'post', url: `${apiBaseUrl}/upload/image` },
  
  plans: {
    create: { method: 'post', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/plan` },
    list: { method: 'get', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/plan` },
    update: { method: 'put', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/plan` },
    delete: { method: 'delete', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/plan` }
  },

  languages: {
    available: { method: 'get', url: `${apiBaseUrl}/languages/available` },
    supported: { method: 'get', url: `${apiBaseUrl}/languages/supported` },
    create: { method: 'post', url: `${apiBaseUrl}/languages` }
    // list: { method: 'get', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/plan` },
    // update: { method: 'put', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/plan` },
    // delete: { method: 'delete', url: `${apiBaseUrl}/sale_groups/{{saleGroupId}}/plan` }
  },
  orders: {
    // create: { method: 'post', url: `${apiBaseUrl}/branches` },
    // get:{ method: 'get', url: `${apiBaseUrl}/branches`},
    list: { method: 'get', url: `${apiBaseUrl}/orders` },
    update: { method: 'put', url: `${apiBaseUrl}/orders` },
    // delete: { method: 'delete', url: `${apiBaseUrl}/stores/` }
    return: { method: 'post', url: `${apiBaseUrl}/orders/{{orderId}}/return` },
    check: { method: 'post', url: `${apiBaseUrl}/orders/check` },
    issueInvoice: { method: 'post', url: `${apiBaseUrl}/orders/{{orderId}}/issueInvoice` },
    cancelInvoice: { method: 'post', url: `${apiBaseUrl}/orders/{{orderId}}/cancelInvoice` },
    createAllowance: { method: 'post', url: `${apiBaseUrl}/orders/{{orderId}}/createAllowance` },
    batchChangeStatus: { method: 'post', url: `${apiBaseUrl}/orders/batchChangeStatus` },
  }



}
